import React, { useEffect, useState } from 'react';

const targetDate = new Date('2025-12-20T09:00:00');

function getTimeLeft() {
  const now = new Date();
  let diff = Math.max(0, targetDate - now);

  const msInSecond = 1000;
  const msInMinute = msInSecond * 60;
  const msInHour = msInMinute * 60;
  const msInDay = msInHour * 24;
  const msInWeek = msInDay * 7;
  const msInMonth = msInDay * 30.4375; // average month

  const months = Math.floor(diff / msInMonth);
  diff -= months * msInMonth;
  const weeks = Math.floor(diff / msInWeek);
  diff -= weeks * msInWeek;
  const days = Math.floor(diff / msInDay);
  diff -= days * msInDay;
  const hours = Math.floor(diff / msInHour);
  diff -= hours * msInHour;
  const minutes = Math.floor(diff / msInMinute);
  diff -= minutes * msInMinute;
  const seconds = Math.floor(diff / msInSecond);

  return { months, weeks, days, hours, minutes, seconds };
}

const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState(getTimeLeft());

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(getTimeLeft());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="countdown-timer" style={{
      position: 'absolute',
      top: 24,
      right: 32,
      background: 'rgba(34,34,34,0.85)',
      color: '#fff',
      padding: '1em 2em',
      borderRadius: 16,
      fontSize: '1.2rem',
      fontWeight: 600,
      boxShadow: '0 2px 16px #0008',
      zIndex: 10,
      letterSpacing: 1,
      textAlign: 'center',
    }}>
      <div style={{ fontSize: '1.1rem', fontWeight: 400, marginBottom: 4 }}>Nedtælling til JULEGOLF 2025</div>
      <span>{timeLeft.months} mdr</span> {' '}
      <span>{timeLeft.weeks} uger</span> {' '}
      <span>{timeLeft.days} dage</span> {' '}
      <span>{timeLeft.hours} t</span> {' '}
      <span>{timeLeft.minutes} min</span> {' '}
      <span>{timeLeft.seconds} sek</span>
      <div style={{ fontSize: '0.8rem', fontWeight: 300, marginTop: 4, opacity: 0.8 }}>20. december 2025 kl. 09:00</div>
    </div>
  );
};

export default CountdownTimer; 